export default {
	title: "Személyes Központ",
	subTitle: ["Profil", "Biztonság", "Rendszer"],
	menu: ["Személyes információk módosítása", "Felhasználónév", "Jelszó frissítése", "Tranzakciós jelszó frissítése"],
	updatePassword: {
		form: {
			label: ["Régi jelszó", "Új jelszó", "Új jelszó megerősítése"]
		}
	},
	updateTransactionPassword: {
		form: {
			label: ["Régi jelszó", "Új jelszó", "Új jelszó megerősítése"]
		}
	}
};
